var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"id":_vm.id,"name":_vm.name,"options":_vm.yearOptions,"state":_vm.state},model:{value:(_vm.selectedYear),callback:function ($$v) {_vm.selectedYear=$$v},expression:"selectedYear"}})}
var staticRenderFns = []

export { render, staticRenderFns }